/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { LeadProductInterestResponseDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class OrganisationLeadController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-lead-controller
   * @name GetLeadProductInterestByOrganisationId1
   * @request GET:/api/v1/organisations/{organisationId}/lead/product-interest
   */
  getLeadProductInterestByOrganisationId = (organisationId: string, params: RequestParams = {}) =>
    this.http.request<LeadProductInterestResponseDto, any>({
      path: `/v1/organisations/${organisationId}/lead/product-interest`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLeadProductInterestByOrganisationIdPath =
    '/v1/organisations/${organisationId}/lead/product-interest'
  static getLeadProductInterestByOrganisationIdMethod = 'GET'
}
